import { truncateText } from "../../common/truncateText.js";
import { arrayOf, bool, string, shape, number } from "prop-types";
// import { useRef, useEffect } from "react";

import cx from "classnames";
import useMatchMedia from "../../common/useMatchMedia.js";

const propTypes = {
  displayImage: bool,
  variantType: number,
  columnCount: number,
  eyebrow: string,
  eyebrowUrl: string,
  title: string.isRequired,
  body: arrayOf(string),
  readTime: string,
  description: string,
  images: shape({
    mobile1X: string,
    desktop1X: string,
    mobile2X: string,
    desktop2X: string,
  }),
  imageAlt: string,
  contentUrl: string,
  variantTwoView: string,
};

const ContentListingItemVariantTwo = (props) => {
  const {
    displayImage,
    variantType,
    columnCount,
    eyebrow,
    eyebrowUrl,
    title,
    body,
    readTime,
    images,
    imageAlt,
    contentUrl,
    variantTwoView,
  } = props;

  let imageSrcSet;
  const matchesDesktop = useMatchMedia("(min-width: 1024px)");

  if (images) {
    matchesDesktop
      ? (imageSrcSet = `
      ${images.desktop1X} 350w,
      ${images.desktop2X} 700w
    `)
      : (imageSrcSet = `
      ${images.mobile1X} 250w,
      ${images.mobile2X} 500w,
      `);
  } else {
    imageSrcSet = null;
  }

  let imageSizes;
  if (variantType === 2) {
    if (columnCount === 2) {
      imageSizes = `
      (min-width: 680px) calc((100vw - 70px - 30px) / 2),
      (min-width: 420px) 350px, 
      calc(100vw - 70px)
    `;
    } else {
      imageSizes = `
      (min-width: 1115px) 350px, 
      (min-width: 746px) calc((100vw - 70px - 60px) / 3), 
      (min-width: 680px) calc((100vw - 70px - 30px) / 2),
      (min-width: 420px) 350px, 
      calc(100vw - 70px)
    `;
    }
  }

  let listingItemHasHover = images?.desktop1X !== "";

  // Potential keyboard enhancements?
  // const contentListingItemRef = useRef(null);
  // useEffect(() => {
  //   let currentContentListingItem = contentListingItemRef?.current;
  //   const handleKeyPress = (event) => {
  //     if (event.code === "Escape") {
  //       // console.log("hit escape", currentContentListingItem);
  //     } else if (event.code === "Tab") {
  //       // console.log("hit tab");
  //     }
  //   };

  //   currentContentListingItem.addEventListener("keydown", handleKeyPress);
  //   return () =>
  //     currentContentListingItem.removeEventListener("keydown", handleKeyPress);
  // }, []);

  return (
    <div
      className={cx("content-listing-item", {
        "content-listing-item--no-image":
          displayImage === false ||
          !images ||
          images?.desktop1X === "" ||
          variantTwoView === "list",
        "content-listing-item--has-hover": listingItemHasHover,
      })}
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex={listingItemHasHover ? 0 : null}
      // ref={contentListingItemRef}
    >
      <div className="content-listing-item__wrapper">
        {images &&
          listingItemHasHover &&
          displayImage &&
          variantTwoView !== "list" && (
            <div className="content-listing-item__image">
              {contentUrl ? (
                <a href={contentUrl} tabIndex={-1}>
                  <img
                    srcSet={imageSrcSet ? imageSrcSet : null}
                    sizes={imageSizes}
                    src={images.mobile1X}
                    alt={imageAlt ? imageAlt : ""}
                    loading="lazy"
                  />
                </a>
              ) : (
                <img
                  srcSet={imageSrcSet ? imageSrcSet : null}
                  sizes={imageSizes}
                  src={images.mobile1X}
                  alt={imageAlt ? imageAlt : ""}
                  loading="lazy"
                />
              )}
            </div>
          )}
        <div className="content-listing-item__text">
          <div className="content-listing-item__news-stories-hover">
            {eyebrow && (
              <div className="content-listing-item__eyebrow">
                {eyebrowUrl ? (
                  <a href={eyebrowUrl}>{eyebrow}</a>
                ) : (
                  <span>{eyebrow}</span>
                )}
              </div>
            )}

            {title && (
              <div className="content-listing-item__title">
                {contentUrl ? (
                  <a href={contentUrl}>{truncateText(title, 82)}</a>
                ) : (
                  truncateText(title, 82)
                )}
              </div>
            )}

            {body && (
              <div className="content-listing-item__body">
                {listingItemHasHover
                  ? truncateText(body[0], 150)
                  : truncateText(body[0], 275)}
              </div>
            )}

            {readTime && (
              <div className="content-listing-item__read-time">{readTime}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

// Specifies the default values for props:
ContentListingItemVariantTwo.defaultProps = {
  columnCount: 3,
};

ContentListingItemVariantTwo.propTypes = propTypes;
export default ContentListingItemVariantTwo;
